import { render, staticRenderFns } from "./BoxeDetails.vue?vue&type=template&id=24a2249e&scoped=true&"
import script from "./BoxeDetails.vue?vue&type=script&lang=js&"
export * from "./BoxeDetails.vue?vue&type=script&lang=js&"
import style0 from "./BoxeDetails.vue?vue&type=style&index=0&id=24a2249e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a2249e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a2249e')) {
      api.createRecord('24a2249e', component.options)
    } else {
      api.reload('24a2249e', component.options)
    }
    module.hot.accept("./BoxeDetails.vue?vue&type=template&id=24a2249e&scoped=true&", function () {
      api.rerender('24a2249e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BoxeDetails.vue"
export default component.exports